module.exports = "//static.hsappstatic.net/ui-addon-upgrades/static-9.7147/js/img/CRM.svg"